import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const PayPub = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Registration Fee | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Pay Registration Fee"
        content="Public Registration"
        contentTwo="Pay Registration Fee"
        linkage="/registration_pub"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div classNameName="entry-header">
          <h3>Registration Fees</h3>
          <br />
          <span className="pay-guide">
            (<a href="paych">中国境内人民币转账支付</a>指导请点击
            <a className="simple-link" href="paych_pub">
              这里
            </a>
            )
          </span>
        </div>

        <div classNameName="entry-content">
          <div className="fee">
            <div align="center">
              <h5>Registration Fees</h5>
            </div>
            <table className="fee">
              <tr>
                <td width={183}>
                  {/* 这里是item 么 */}
                  <p align="center">Type </p>
                </td>
                <td width={152}>
                  <p align="center">Fee (USD) </p>
                </td>
                <td width={691}>
                  <p align="center"> Remarks </p>
                </td>
              </tr>
              {/* <tr>
                <td width={183}>
                  <p align="center">Normal Registration </p>
                </td>
                <td width={152}>
                  <p align="center">816.00</p>
                </td>
                <td width={691}>
                  <p>
                    This is applicable to the participant with one accepted
                    paper.
                    <br />
                    Including: One paper published in Springer-LNCS Proceedings,
                    electronic version of proceedings, conference program book,
                    conference bag, badge, attendance at all conference
                    presentations, all conference activities, etc. <br />
                  </p>
                </td>
              </tr> */}
                {/* <tr>
                <td width={183}>
                  <p align="center">Normal Registration </p>
                </td>
                <td width={152}>
                  <p align="center">816.00</p>
                </td>
                <td width={691}>
                  <p>
                    This is applicable to the participant with one accepted
                    paper.
                    <br />
                    Including: One paper published in Springer-LNCS Proceedings,
                    electronic version of proceedings, conference program book,
                    conference bag, badge, attendance at all conference
                    presentations, all conference activities, etc. <br />
                  </p>
                </td>
              </tr> */}
              <tr>
                <td>
                  <div align="center">Reduced Registration</div>
                </td>
                <td>
                  <div align="center">683.00</div>
                </td>
                <td>
                  {/* <div align="center"> */}
                    This is applicable to the participant without paper publication or accompanied participants.
                  {/* </div> */}
                </td>
              </tr>

              {/* <tr>
                <td colSpan={3}>&nbsp;</td>
              </tr> */}

              {/* <tr>
                <td width={183}>
                  <p align="center"> Page Surcharge</p>
                </td>
                <td width={152}>
                  <p align="center">125</p>
                </td>
                <td width={691}>
                  <p align="left">Each extra page if more than 12 pages. </p>
                </td>
              </tr>
               */}

              {/* <tr>
                <td width={183}>
                  <p align="center">Banquet Ticket </p>
                </td>
                <td width={152}>
                  <p align="center">100</p>
                </td>
                <td width={691}>
                  <p align="center">Per Banquet Ticket</p>
                </td>
              </tr> */}


              {/* <tr>
                <td width={183}>
                  <p align="center">Lunch Ticket</p>
                </td>
                <td width={152}>
                  <p align="center">50</p>
                </td>
                <td width={691}>
                  <p align="center">Per Lunch Ticket</p>
                </td>
              </tr> */}


            </table>
            <br />
            <b>Note:</b>
            <ul>
              <li>
                About invoices: This international conference will provide
                English receipts by default.

              </li>
            </ul>
          </div>
          <p>&nbsp;</p>
          <hr />
          <p>&nbsp;</p>
          {/* PayPal */}

          <div className="post-entry">
            {" "}
            <span className="STYLE27">
              <span className="STYLE28">1. Recommend: </span>
            </span>
            <span className="STYLE27">
              <span className="STYLE27">
                <span className="STYLE27">
                  <span className="STYLE27">
                    <a
                      href="http://www.paypal.com"
                      onClick="javascript:window.open('https://www.paypal.com/cgi-bin/webscr?cmd=xpt/Marketing/popup/OLCWhatIsPayPal-outside','olcwhatispaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=400, height=350');"
                    >
                      <img
                        src="./images/reg/usbstep2_bnr_nowAccepting_150x60.gif"
                        alt="Additional Options"
                        width={127}
                        height={45}
                        border={0}
                      />
                    </a>
                  </span>
                </span>
              </span>
            </span>
            <span className="crucial2">
              Payment can be easily and fast made through &quot;PayPal&quot;by
              clicking the following{" "}
            </span>
            <img
              src="./images/reg/usbstep2_btn_cart_LG.gif"
              alt="button"
              width={120}
              height={26}
            />
            <span className="crucial2"> buttons</span>
            .
            <br />
            <br />
            <table
              className="paypal"
              width="84%"
              height={151}
              border={1}
              bordercolor="#333333"
              bgcolor="#fff"
            >
              <tr>
                <th width={581} height={54} scope="col">
                  <div align="center">Items</div>
                </th>
                <th width={714} scope="col">
                  <div align="center">Your Selection(s)</div>{" "}
                </th>
              </tr>
              <tr>
                <td height={89}>
                  <div align="center">DMBD&apos;2025 Registrations </div>
                </td>
                <td>
                  <div align="center">
                  <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">
                    <input type="hidden" name="cmd" value="_s-xclick" />
                    <input type="hidden" name="hosted_button_id" value="26BRGAYGFWPTS" />
                    <table>
                      <tr>
                        <td>
                          <input type="hidden" name="on0" value="Iterms"/>
                          Iterms
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <select name="os0">
                            <option value="Reduced Registration">
                              Reduced Registration $683.00 USD
                            </option>
                            <option value="Small Change">
                              Small Change $1.00 USD
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input type="hidden" name="on1" value="Please input your name:"/>
                          Please input your name:
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input type="text" name="os1" maxLength="200" />
                        </td>
                      </tr>
                    </table>
                    <input type="hidden" name="currency_code" value="USD" />
                    <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_cart_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Add to Cart" />
                  </form>
                    {/* <form
                      target="paypal"
                      action="https://www.paypal.com/cgi-bin/webscr"
                      method="post"
                    >
                      <input type="hidden" name="cmd" value="_s-xclick" />
                      <input
                        type="hidden"
                        name="hosted_button_id"
                        value="WLY28BXMY3HLQ"
                      />
                      <table>
                        <tr>
                          <td>
                            <input type="hidden" name="on0" value="Iterms" />
                            Iterms
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <select name="os0">
                              <option value="Reduced Registration">
                                Registration $683.00 USD
                              </option>
                              <option value="Small">
                                Small charge $1.00 USD
                              </option>
                            </select>{" "}
                          </td>
                        </tr>
                      </table>
                      <input type="hidden" name="currency_code" value="USD" />
                      <input
                        type="image"
                        src="https://www.paypalobjects.com/en_US/i/btn/btn_cart_LG.gif"
                        border={0}
                        name="submit"
                        alt="PayPal - The safer, easier way to pay online!"
                      />
                      <img
                        alt=""
                        border={0}
                        src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                        width={1}
                        height={1}
                      />
                    </form> */}
                  </div>
                </td>
              </tr>
            </table>
            {/* </blockquote> */}
            <b>Note:</b>
            <br />
            <ul>
              <li>
                Please save your PayPal transaction page as .JPG file for
                filling your online registration form.
              </li>
              <li>
                If you buy multiple items, please add them to the shopping cart
                together and then pay together.
              </li>
            </ul>
            <ul>
              {/* instruction */}
              {/* <li style="font-style: italic"><a href="usb.html">Back to Registration page</a></li> */}
            </ul>
            <p>&nbsp;</p>
            <hr />
            <p>&nbsp;</p>
          </div>

          <div className="post-entry">
            <p>
              <span className="pay-method">2. Bank Transfer: </span>
              <span className="crucial2">
                If you have a difficulty in using above PayPal payment, you can
                pay your registration fee by using the following bank account
                (collecting for DMBD&apos;2025 conference):
              </span>
            </p>
            {/* <div className="ac-1">
              <h5>Bank Account ONE:</h5>
              <p>
                (a) Beneficiary:&nbsp;
                <strong>YAN JIN (HONGKONG) INDUSTRIAL CO. LIMITED </strong>
                <br />
                (b) Beneficiary&apos;s Account No.:
                <strong> 509739181-838 </strong>
                <br />
                (c) Bank&apos;s Name:<strong> HSBC Hong Kong</strong>
                <br />
                (d) Address of Bank:
                <strong> 1 Queen&apos;s Road Central, Hong Kong </strong>
                <br />
                (e) Swift Code:<strong>HSBCHKHHHKH</strong>
                <br />
                <br />
                (f) Message: Following information should be added as the
                postscript of bank transfer:{" "}
                <strong>
                  &quot;Payment for ICSI2022/XXX &quot; (XXX is the name of
                  participant).{" "}
                </strong>
                <br />
                (g) Please scan the receipt of your bank transfer with
                &quot;ICSI2022/XXX &quot; (XXX is the name of participant) as
                JPG file for filling your{" "}
                <a href="./form">online registration form.</a> <br />
                <br></br>
              </p>
            </div> */}

            <div className="ac-2">
              {/* <h5>Bank Account TWO:</h5> */}
              <p>
                (a) Beneficiary&apos;s Account No.:&nbsp;
                <strong>11014748324007</strong>
                <br />
                (b) Beneficiary&apos;s Name:&nbsp;
                <strong> Beijing Xinghui Hi-Tech Co., LTD</strong>
                <br />
                (c) Beneficiary&apos;s Address :&nbsp;
                <strong>
                  No. 308, Huaibei Road, Huaibei Town, Huairou District,
                  Beijing, China
                </strong>
                <br />
                (d) Bank&apos;s Name: &nbsp;
                <strong>
                  PING AN BANK CO.,LTD(FORMERLY SHENZHEN DEVELOPMENT BANK), H.O.{" "}
                </strong>
                <br />
                (e) Bank&apos;s Address: &nbsp;
                <strong>
                  Ping An Bank Co., Ltd. Beijing Zhongguancun Branch
                </strong>
                <br />
                (f) Swift BIC:&nbsp;
                <strong>SZDBCNBS</strong>
                <br />
                <br />
                (g) Message: Following information should be added as the
                postscript of bank transfer:{" "}
                <strong>
                  &quot;Payment for DMBD2025/xxxx &quot; (xxxx is the name of
                  participant).
                </strong>
                <br />
                (h) Please scan the receipt of your bank transfer with
                &quot;DMBD2025/xxxx &quot; (xxxx is the name of participant) as
                JPG file for filling your{" "}
                <a href="./form">online registration form.</a> <br />
                <br></br>
              </p>
            </div>

            <p>
              <span>
                <strong>Notice:</strong>
              </span>
              <li>
                Transfer in EUR/JPY/GBP at the real time exchange rate is
                acceptable.{" "}
              </li>
              <li>
                Note that please save your Transaction page as a JPG/PNG/PDF
                file for filling your Online Registration Form.
              </li>
              <li>If you have any questions. Please send email to dmbd2025@iasei.org</li>
            </p>
          </div>
          <p align="center">&nbsp;</p>
          <div className="btn-nav-pay">
            {/* <a
              className="btn btn-primary btn-hover-secondary mt-s"
              href="https://wj.qq.com/s2/9997438/2b92/"
            >
              Fill Online Registration Form
            </a> */}
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/form_pub"}
            >
              Fill Online Registration Form
              {/* Back to Registration page */}
            </Link>
            <br />
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/registration_pub"}
            >
              Back to Registration page
            </Link>

            {/* <p>
              <a href="/Registration">Back to Registration page </a>
            </p>
            <p>
              <a href="https://iasei.org/survey/index.php/677672?lang=en">
                Fill Online Registration Form{" "}
              </a>
            </p> */}
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classNameOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
}
else{
  return (
<React.Fragment>
      <SEO title="Registration Fee | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Pay Registration Fee"
        content="Public Registration"
        contentTwo="Pay Registration Fee"
        linkage="/registration_pub"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div classNameName="entry-header">
          <h3>Registration Fees</h3>
          <br />
          <span className="pay-guide">
            (<a href="paych">中国境内人民币转账支付</a>指导请点击
            <a className="simple-link" href="./paych_pub">
              这里
            </a>
            )
          </span>
        </div>

        <div classNameName="entry-content">
          <div className="fee">
            <div align="center">
              <h5>Registration Fees</h5>
            </div>
            <table className="fee">
              <tr>
                <td width={183}>
                  {/* 这里是item 么 */}
                  <p align="center">Type </p>
                </td>
                <td width={152}>
                  <p align="center">Fee (USD) </p>
                </td>
                <td width={691}>
                  <p align="center"> Remarks </p>
                </td>
              </tr>
                <tr>
                <td width={183}>
                  <p align="center">Normal Registration </p>
                </td>
                <td width={152}>
                  <p align="center">816.00</p>
                </td>
                <td width={691}>
                  <p>
                    This is applicable to the participant with one accepted
                    paper.
                    <br />
                    Including: One paper published in Springer-LNCS Proceedings,
                    electronic version of proceedings, conference program book,
                    conference bag, badge, attendance at all conference
                    presentations, all conference activities, etc. <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <div align="center">Reduced Registration</div>
                </td>
                <td>
                  <div align="center">683.00</div>
                </td>
                <td>
                  {/* <div align="center"> */}
                    This is applicable to the participant without paper publication or accompanied participants.
                  {/* </div> */}
                </td>
              </tr>


            </table>
            <br />
            <b>Note:</b>
            <ul>
              <li>
                About invoices: This international conference will provide
                English receipts by default.

              </li>
            </ul>
          </div>
          </div>
          <p>&nbsp;</p>
          <hr />
          <p>&nbsp;</p>
          </EmptyTwo>
          <Footer />
      <ScrollToTop />
    </React.Fragment>
  )
}
};
export default PayPub;
